import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild, CanActivate, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MenuService, MENU_TOKEN } from '@awp/app-common';
import { isNullOrEmpty } from '@awp/core/utils';
import { ThemeService } from '@awp/theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeNoMenuGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    @Inject(MENU_TOKEN) private menuService: MenuService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | UrlTree | boolean {
    const themeId = route.paramMap.get('themeId');
    if (isNullOrEmpty(themeId)) {
      return this.router.createUrlTree(['page/not-found']);
    }

    const url = this.extractUrl(state.url);
    if (url.endsWith(themeId)) {
      return this.resolveMainMenu(themeId, route.queryParams);
    } else {
      return true;
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const themeId = childRoute.paramMap.get('themeId');
    const url = this.extractUrl(state.url);
    if (url.endsWith(themeId)) {
      return this.resolveMainMenu(themeId, childRoute.queryParams)
    } else {
      return true;
    }
  }

  resolveMainMenu(themeId: string, queryParams: Params): Observable<UrlTree> {
    return this.menuService.values
        .pipe(
          map(items => {
            const tree = this.router.createUrlTree(['/', themeId, items[0].url], { replaceUrl: true, queryParams });
            return tree;
          }),
          take(1)
        );
  }

  extractUrl(url: string): string {
    if (url != null && url.includes('?')) {
      return url.substr(0, url.indexOf('?'));
    }
    return url;
  }
}
